import React, { useState } from "react";
import "./services.css";

const Services = () => {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className="services section" id="services">
      <h2 className="section__title">Services</h2>
      <span className="section__subtitle">What i offer</span>

      <div className="services__container container grid">
        <div className="services__content"></div>

        <div className="services__content">
          <div>
            <i className="uil uil-arrow services__icon"></i>
            <h3 className="services__title">
              Software <br /> Engineer
            </h3>
          </div>

          <span onClick={() => toggleTab(2)} className="services__button">
            View More
            <i className="uil uil-arrow-right services__button-icon"></i>
          </span>

          <div
            className={
              toggleState === 2
                ? "services__modal active-modal"
                : "services__modal"
            }
          >
            <div className="services__modal-content">
              <i
                onClick={() => toggleTab(0)}
                className="uil uil-times services__modal-close"
              ></i>

              <h3 className="services__modal-title">Software Engineer</h3>
              <p className="services__modal-description">
                2 years of work experience. Delivering quality componets and
                products.
              </p>

              <ul className="services__modal-services grid">
                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    Successfully transitioned crucial JavaScript components to
                    TypeScript, significantly enhancing code robustness and type
                    safety, leading to a more stable and reliable application.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    Expertly integrated and refined type annotations across the
                    codebase, greatly improving code clarity and
                    maintainability, and simplifying future development
                    processes.
                  </p>
                </li>

                <li className="services__modal-service">
                  <i className="uil uil-check-circle services__modal-icon"></i>
                  <p className="services__modal-info">
                    Designed and developed over 10 distinct report pages
                    utilizing a specialized component library, effectively
                    streamlining the presentation and manipulation of complex
                    financial data.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="services__content"></div>
      </div>
    </section>
  );
};

export default Services;
